import tag from './tag';

export const semtantic = (value: any) => tag(value);

export default semtantic;
